import React, { useContext, useState } from "react";
import { get, isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import {
  ManagePlanLayout,
  FieldButtonGroup,
  FieldMultiSelectButtonGroup,
  FieldInputNumber,
  FieldInputPercentage,
  FieldDropSide,
  DatePicker,
  DayDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  yesNoOptions,
  required,
  ROUTES,
  getAdvancedPathWithParam,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  usDateFormat,
  clearFieldValues,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  setManagePlanFlow,
  setManagePageLevelData,
  savePlanDetailsAction,
} from "../../../contexts";
import { useRouterParams, useRequest } from "../../../abstracts";
import { listTransfer, saveTransfer } from "../../../services";

const TransferContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const [newFlow] = useState("");
  const { planId, flow } = useRouterParams();
  const formName = managePlanFormNames.ADD_TRANSFER;
  const fields = formFields[formName];
  const apiData = get(state, "api.data", {});

  const { response: transfers, loading: isLoading } = useRequest({
    method: listTransfer,
    payload: parseInt(planId),
    defaultResponse: [],
  });

  const transferApiData = get(transfers, "transfers", []);
  let transferData = get(transferApiData, "[0]", {});

  const schema = Yup.object().shape({
    // pctDollarAmount: Yup.string()
    //   .required("Required")
    //   .test("pctDollarAmount", "Percentage cannot be greater than 100", (val) =>
    //     val <= 100 ? true : false
    //   )
    //   .max(6, "Percentage cannot be greater than 6 characters"),
  });
  const buttons = [
    {
      link: getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.TRANSFER,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: ROUTES.PLAN,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.TRANSFER,
            pathParam: [FLOW_TYPES.SAVE, planId],
          })
        ),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];
  const [apiLoading, setApiLoading] = useState(false);
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    const { history } = props;
    setApiLoading(true);
    saveTransfer(
      {
        ...values,
        planId: parseInt(planId),
        [fields.typesPermitted]: values[fields.isTransferAllowed]
          ? values[fields.typesPermitted]
          : [],
        [fields.rebalanceTypesPermitted]: values[fields.rebalanceAllowed]
          ? values[fields.rebalanceTypesPermitted]
          : [],
        [fields.timing]: values[fields.isAutoRebalanceAllowed]
          ? values[fields.timing]
          : 0,
      },
      dispatch,
      state
    ).then((response) => {
      setApiLoading(false);

      setSubmitting(false);
      if (response.isSuccessful) {
        setSubmitting(true);
        const newPlanId = get(response, "plan.id");
        // dispatch(
        //   setManagePlanFlow({
        //     planId: newPlanId,
        //   })
        // );
        dispatch(
          setManagePageLevelData({
            formName: formName,
            fieldData: values,
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.TRANSFER,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      } else {
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };

  const initialValues = {
    [fields.showProspectusWithFirstTransfer]: false,
    [fields.showProsPectusWithEachTransfer]: false,
    [fields.isTransferAllowed]: false,
    [fields.rebalanceAllowed]: false,
    [fields.isReallocationAllowed]: false,
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...transferData,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      // validationSchema={schema}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        values,
        setValues,
        ...rest
      }) => {
        return (
          <LoaderWrapper isLoading={isLoading || apiLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout buttons={buttons} pageFlow={newFlow || flow}>
                <Field
                  isRequired
                  size="sm"
                  name={fields.isTransferAllowed}
                  label={"Is Transfer allowed?"}
                  options={yesNoOptions}
                  selectedValue={values[fields.isTransferAllowed]}
                  value={values[fields.isTransferAllowed]}
                  onChange={(value) => {
                    setFieldValue(fields.isTransferAllowed, value);
                    setFieldValue(fields.typesPermitted, null);
                    setFieldValue(fields.numberOfTransfersAllowed, null);
                    setFieldValue(fields.transferFrequency, null);
                    setFieldValue(fields.transfersCountStartsFrom, null);
                    setFieldValue(fields.showProsPectusWithEachTransfer, false);
                    setFieldValue(
                      fields.showProspectusWithFirstTransfer,
                      false
                    );
                  }}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                />
                {values[fields.isTransferAllowed] && (
                  <div>
                    <p className="plan-sub-heading mt-2">Prospectus Notice</p>
                    <Field
                      isRequired
                      size="sm"
                      name={fields.showProsPectusWithEachTransfer}
                      label={"Show Prospectus Notice with each Transfer?"}
                      options={yesNoOptions}
                      selectedValue={
                        values[fields.showProsPectusWithEachTransfer]
                      }
                      value={values[fields.showProsPectusWithEachTransfer]}
                      onChange={(value) => {
                        setFieldValue(
                          fields.showProspectusWithFirstTransfer,
                          false
                        );
                        setFieldValue(
                          fields.showProsPectusWithEachTransfer,
                          value
                        );
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                    {!values.showProsPectusWithEachTransfer && (
                      <Field
                        isRequired
                        size="sm"
                        name={fields.showProspectusWithFirstTransfer}
                        label={
                          "Show Prospectus Delivery notice with First Transfer?"
                        }
                        options={yesNoOptions}
                        selectedValue={
                          values[fields.showProspectusWithFirstTransfer]
                        }
                        value={values[fields.showProspectusWithFirstTransfer]}
                        onChange={(value) => {
                          setFieldValue(
                            fields.showProspectusWithFirstTransfer,
                            value
                          );
                        }}
                        component={FieldButtonGroup}
                        disabled={isEdit && !isSave}
                      />
                    )}
                    {/* <pre>{JSON.stringify(values,null,2)}</pre> */}
                    <Field
                      size="sm"
                      isRequired
                      name={fields.typesPermitted}
                      label={"Modes of Transfer"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.TRANSFER_TYPE
                      )}
                      selectedValue={values[fields.typesPermitted]}
                      value={values[fields.typesPermitted]}
                      onChange={(value) => {
                        setFieldValue(fields.typesPermitted, value);
                      }}
                      component={FieldMultiSelectButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                    <p className="plan-sub-heading mt-2">
                      Transfer Restrictions
                    </p>
                    <Field
                      size="smd"
                      isRequired
                      name={fields.numberOfTransfersAllowed}
                      label={"Number of Allowed Transfers"}
                      type="number"
                      autoComplete="off"
                      value={values[fields.numberOfTransfersAllowed]}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      min={1}
                      max={99}
                      disabled={isEdit && !isSave}
                      component={FieldInputNumber}
                    />
                    <Field
                      isRequired
                      size="smd"
                      name={fields.transferFrequency}
                      label={"Transfer Frequency"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.TRANSFER_FREQUENCY
                      )}
                      selectedValue={values[fields.transferFrequency]}
                      value={values[fields.transferFrequency]}
                      onChange={(value) => {
                        setFieldValue(fields.transferFrequency, value);
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                    <Field
                      isRequired
                      size="smd"
                      name={fields.transfersCountStartsFrom}
                      label={"Transfer Count Starts From"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.TRANSFER_COUNT_STARTS_FROM
                      )}
                      selectedValue={values[fields.transfersCountStartsFrom]}
                      value={values[fields.transfersCountStartsFrom]}
                      onChange={(value) => {
                        setFieldValue(fields.transfersCountStartsFrom, value);
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                  </div>
                )}
                <p className="plan-sub-heading mt-2">Rebalance</p>
                <Field
                  isRequired
                  size="sm"
                  name={fields.rebalanceAllowed}
                  label={"Rebalancing Allowed?"}
                  options={yesNoOptions}
                  selectedValue={values[fields.rebalanceAllowed]}
                  value={values[fields.rebalanceAllowed]}
                  onChange={(value) => {
                    setFieldValue(fields.rebalanceAllowed, value);
                    setFieldValue(fields.rebalancingThreshold, null);
                    setFieldValue(fields.periodicRebalancingRequired, null);
                    setFieldValue(fields.rebalanceFrequency, null);
                    setFieldValue(fields.rebalancingDay, null);
                    setFieldValue(fields.firstRebalancingDate, null);
                  }}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                />
                {values[fields.rebalanceAllowed] && (
                  <div>
                    <Field
                      size="smd"
                      isRequired
                      name={fields.rebalancingThreshold}
                      label={"Rebalancing Threshold %"}
                      type="number"
                      autoComplete="off"
                      value={values[fields.rebalancingThreshold]}
                      min={0}
                      max={99.99}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldInputPercentage}
                    />
                    <Field
                      isRequired
                      size="smd"
                      name={fields.periodicRebalancingRequired}
                      label={"Periodic Rebalancing Required?"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.PERIODIC_REBALANCE_REQUIRED
                      )}
                      selectedValue={values[fields.periodicRebalancingRequired]}
                      value={values[fields.periodicRebalancingRequired]}
                      onChange={(value) => {
                        const updatedValues = clearFieldValues({
                          values,
                          fieldsToClear: [
                            fields.firstRebalancingDate,
                            fields.rebalanceFrequency,
                            fields.rebalancingDay,
                          ],
                        });
                        setValues({
                          ...updatedValues,
                          [fields.periodicRebalancingRequired]: value,
                        });
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />

                    {values[fields.periodicRebalancingRequired] == 1 && (
                      <div>
                        <Field
                          size="smd"
                          isRequired
                          name={fields.rebalanceFrequency}
                          label={"Rebalancing Frequency"}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.TRANSFER_FREQUENCY
                          )}
                          selectedValue={values[fields.rebalanceFrequency]}
                          value={values[fields.rebalanceFrequency]}
                          onChange={(value) => {
                            setFieldValue(fields.rebalanceFrequency, value);
                          }}
                          component={FieldButtonGroup}
                          disabled={isEdit && !isSave}
                        />
                        <Field
                          isRequired
                          name={fields.rebalancingDay}
                          label={"Rebalancing Day"}
                          {...rest}
                          size="xs"
                          placeholder="Date"
                          value={values[fields.rebalancingDay]}
                          disabled={isEdit && !isSave}
                          popupContent={
                            <DayDropdown
                              fromMonthDate={
                                new Date(
                                  2019,
                                  values[fields.rebalancingDay] - 1 || 0
                                )
                              }
                              onSelect={(value) => {
                                setFieldValue(fields.rebalancingDay, value);
                              }}
                              value={values[fields.rebalancingDay]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                    )}
                    {values[fields.periodicRebalancingRequired] === 1 && (
                      <Field
                        size="smd"
                        name={fields.firstRebalancingDate}
                        placeholder="To"
                        value={usDateFormat(
                          values[fields.firstRebalancingDate]
                        )}
                        direction="right"
                        isDatePicker
                        isRequired
                        label="First Rebalancing Date"
                        onClear={() =>
                          setFieldValue(fields.firstRebalancingDate, "")
                        }
                        popupContent={
                          <DatePicker
                            onDayClick={(value) => {
                              setFieldValue(fields.firstRebalancingDate, value);
                            }}
                            value={usDateFormat(
                              values[fields.firstRebalancingDate]
                            )}
                          />
                        }
                        disabled={isEdit && !isSave}
                        component={FieldDropSide}
                      />
                    )}
                  </div>
                )}

                <p className="plan-sub-heading mt-2">Reallocation</p>
                <Field
                  isRequired
                  size="sm"
                  name={fields.isReallocationAllowed}
                  label={"Reallocation allowed?"}
                  options={yesNoOptions}
                  selectedValue={values[fields.isReallocationAllowed]}
                  value={values[fields.isReallocationAllowed]}
                  onChange={(value) => {
                    setFieldValue(fields.isReallocationAllowed, value);
                    setFieldValue(fields.reallocationLimit, null);
                    setFieldValue(fields.reallocationFrequency, null);
                    setFieldValue(fields.reAllocationOnCountStartsFrom, null);
                  }}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                />
                {values[fields.isReallocationAllowed] && (
                  <div>
                    <Field
                      size="smd"
                      isRequired
                      name={fields.reallocationLimit}
                      label={"Reallocation Limit"}
                      type="number"
                      autoComplete="off"
                      value={values[fields.reallocationLimit]}
                      min={1}
                      max={99}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldInputNumber}
                    />
                    <Field
                      size="smd"
                      isRequired
                      name={fields.reallocationFrequency}
                      label={"Reallocation Frequency"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.TRANSFER_FREQUENCY
                      )}
                      selectedValue={values[fields.reallocationFrequency]}
                      value={values[fields.reallocationFrequency]}
                      onChange={(value) => {
                        setFieldValue(fields.reallocationFrequency, value);
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                    <Field
                      size="smd"
                      isRequired
                      name={fields.reAllocationOnCountStartsFrom}
                      label={"Reallocation Count Starts From"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.REALLOCATION_COUNT_STARTS_FROM
                      )}
                      selectedValue={
                        values[fields.reAllocationOnCountStartsFrom]
                      }
                      value={values[fields.reAllocationOnCountStartsFrom]}
                      onChange={(value) => {
                        setFieldValue(
                          fields.reAllocationOnCountStartsFrom,
                          value
                        );
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                  </div>
                )}
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default TransferContainer;
